import React, { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { useIsEdited } from "../../Providers/IsEditedProvider";


const AutoCompleteElement = (props) => {
  const [value, setValue] = useState(props.value);
  const [items, setItems] = useState(props.items);
  const [filteredItems, setFilteredItems] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const { setIsEdited } = useIsEdited();

  // Method to handle value change
  const changeValue = (e) => {
    setValue(e.value);
    setIsEdited(true);
    props.onChangeValue(e);
  };

  // Function to filter items based on the input
  const search = (event) => {
    const query = event.query.toLowerCase();
    if (query === "") {
      setFilteredItems(props.items);
      setNoResults(false);
    } else {
      const filtered = items?.filter((item) =>
        item.external_email.toLowerCase().includes(query)
      );
      setFilteredItems(filtered);
      setNoResults(filtered?.length === 0);
    }
  };

  // Update items when props.items change
  useEffect(() => {
    if (props.items !== undefined) {
      setItems(props.items);
    }
  }, [props.items]);

  return (
    <>
    {
      props.isPurposeScore && <AutoComplete
      id={props.id}
      value={props.value}
      suggestions={props.suggestions }
      completeMethod={props.completeMethod }
      onFocus={(e) => search({ query: "" })}
      placeholder={props.placeholder}
      onChange={changeValue}
      emptyMessage="No results found"
      register={props.register}
      disabled={props.disabled}
    />
    }
      {!props.isPurposeScore && <AutoComplete
        id={props.id}
        value={props.value}
        suggestions={filteredItems}
        completeMethod={ search}
        onFocus={(e) => search({ query: "" })}
        field="external_email"
        placeholder={props.placeholder}
        onChange={changeValue}
        emptyMessage="No results found"
        register={props.register}
      />}
    </>
  );
};

export default AutoCompleteElement;
